export default {
  sidebar: {
    personalAccount: "Личный кабинет",
    menu: "меню",
    home: "Главная",
    services: "Услуги",
    myRequests: "Мои заявки",
    callHistory: "Мои звонки",
    osintSearch: "Time to search",
    help: "Помощь",
    logout: "Выход",
    logoutConfirmTitle: "Подтверждение",
    logoutConfirmMessage: "Вы уверены, что хотите выйти?",
    logoutConfirmYes: "Да",
    logoutConfirmNo: "Нет",
    helpNotAvailable: "Раздел помощи скоро будет доступен",
    language: "Язык",
    theme: "Тема",
    lightTheme: "Светлая",
    darkTheme: "Тёмная",
    darkThemeLabel: "Тёмная тема",
    lightThemeLabel: "Светлая тема",
    call: "Связь",
    callOperator: "Связаться с оператором",
    videoCall: "Видео",
    audioCall: "Аудио",
    textChat: "Текст",
  },
  login: {
    clientPortal: "Клиентский портал",
    greeting: "Клиентский портал",
    description:
      "Управляйте услугами, отслеживайте заявки и контролируйте статусы в одном интерфейсе.",
    descriptionTagline: "Быстро. Понятно. По делу.",
    copyright: "© {year} Клиентский портал. Все права защищены.",
    welcomeTitle: "Добро пожаловать в",
    welcomeSubtitle: "клиентский портал",
    registerTitle: "Создать аккаунт",
    verifyTitle: "Подтверждение email",
    noAccount: "Нет аккаунта?",
    createAccount: "Зарегистрироваться",
    hasAccount: "Уже есть аккаунт?",
    loginLink: "Войти",
    noAccess: "Нет доступа?",
    contactAdmin: "Обратитесь к администратору",
    emailPlaceholder: "Email",
    passwordPlaceholder: "Пароль",
    firstNamePlaceholder: "Имя",
    lastNamePlaceholder: "Фамилия",
    otpPlaceholder: "Код из письма",
    otpHint: "Введите 6-значный код, отправленный на ваш email",
    loginButton: "Войти",
    registerButton: "Зарегистрироваться",
    verifyButton: "Подтвердить",
    backToLogin: "Назад к входу",
    loginWithGoogle: "Войти через Google",
    loginWithApple: "Войти через Apple",
    forgotPassword: "Забыли пароль?",
    emailError: "Не удалось получить email пользователя",
    invalidEmail: "Введите корректный email",
    tempLoginSuccess: "Временный вход выполнен",
    authError: "Ошибка авторизации",
    emailNotVerified: "Email не подтверждён. Введите код из письма",
    emailAlreadyExists: "Этот email уже зарегистрирован",
    registerError: "Ошибка регистрации",
    otpSent: "Код подтверждения отправлен на email",
    otpInvalid: "Неверный или просроченный код",
    oauthError: "Ошибка авторизации через внешний сервис",
    googleError: "Ошибка входа через Google",
    appleError: "Ошибка входа через Apple",
    forgotTitle: "Восстановление пароля",
    forgotPrompt: "Введите email для получения кода",
    forgotButton: "Отправить код",
    resetPasswordTitle: "Установка нового пароля",
    resetPasswordPrompt: "Введите код из письма и новый пароль",
    resetPasswordButton: "Сохранить",
    confirmPasswordPlaceholder: "Повторите пароль",
    passwordMin6: "Минимум 6 символов",
    passwordMismatch: "Пароли не совпадают",
    resendCode: "Отправить код повторно",
    codeResent: "Код отправлен на email",
    passwordResetSuccess: "Пароль обновлён, войдите снова",
    resetCodeInvalid: "Неверный или просроченный код",
  },
  validation: {
    fieldRequired: "Поле не должно быть пустым",
    invalidCredentials: "Неправильный логин или пароль",
    networkError:
      "Проблема с сетью. Проверьте подключение или попробуйте позже.",
  },
  chat: {
    howCanIHelp: "Как я могу вам помочь?",
    interestedInService: "Интересует услуга: {service}",
    detectingIntent: "Подбираю подходящие услуги...",
    foundForms: "Найдено услуг: {count}. Выберите подходящую:",
    noFormFound:
      "Не удалось подобрать подходящую услугу. Попробуйте описать задачу подробнее.",
    noFormsAvailable: "В системе пока нет доступных услуг.",
    intentError: "Сервис временно недоступен. Попробуйте позже.",
  },
  services: {
    title: "Услуги",
    newRequest: "Новая заявка",
    emptyList: "Список услуг пуст",
    fields: "{count} полей",
    otherServices: "Прочие услуги",
    cancel: "Отмена",
    submit: "Отправить",
    fillField: "Заполните поле: {field}",
    requestSent: "Заявка отправлена",
    active: "Активна",
    inactive: "Неактивна",
    stages: {
      initiation: "Инициация заявки",
      initiationSub: "Выбор услуги, места подачи, типа паспорта.",
      preliminaryCheck: "Предварительная проверка",
      preliminaryCheckSub: "Проверка полноты/валидности/оплаты.",
      verification: "Верификация личности",
      verificationSub: "Сверка по базам, уточнения.",
      closing: "Закрытие кейса",
      closingSub: "Подтверждение возвращения/итога.",
    },
    visa: {
      stepPurpose: "Цель визита",
      stepPurposeDesc: "Цель и даты поездки",
      stepPersonal: "Личные данные",
      stepPersonalDesc: "ФИО, контакты, гражданство",
      stepPassport: "Паспорт",
      stepPassportDesc: "Номер и срок действия",
      stepTravel: "Пребывание",
      stepTravelDesc: "Организация и адрес",
      stepDocuments: "Документы",
      stepDocumentsDesc: "Фото, скан, приглашение",
      stepReview: "Проверка",
      stepReviewDesc: "Проверка перед отправкой",
      purposeTitle: "Цель визита",
      purposeDesc: "Укажите цель вашего визита и планируемые даты пребывания.",
      personalTitle: "Личные данные заявителя",
      personalDesc:
        "Заполните данные о заявителе. Поля отмеченные * обязательны.",
      passportTitle: "Данные паспорта",
      passportDesc: "Укажите номер паспорта и срок его действия.",
      travelTitle: "Данные о пребывании",
      travelDesc:
        "Укажите принимающую организацию и адрес пребывания в стране.",
      documentsTitle: "Фото и документы",
      documentsDesc:
        "Загрузите фотографию, скан паспорта и приглашение (если есть).",
      photoRequirements: "Требования к фото",
      photoRule1: "Размер: 35 x 45 мм",
      photoRule2: "Цветное фото на светлом фоне",
      photoRule3: "Лицо занимает 70-80% кадра",
      photoRule4: "Без головных уборов (кроме религиозных)",
      photoRule5: "Без очков с тонированными линзами",
      photoRule6: "Формат: JPEG или PNG, не более 5 МБ",
      uploadFile: "Загрузить файл",
      uploadError: "Ошибка загрузки файла",
      fileAttached: "Файл прикреплён",
      reviewTitle: "Проверка данных",
      reviewDesc: "Проверьте введённые данные перед отправкой заявки.",
      back: "Назад",
      next: "Далее",
    },
  },
  requests: {
    title: "Мои заявки",
    newRequest: "Новая заявка",
    emptyList: "Пока нет заявок",
    stage: "Этап: {stage}",
    defaultStage: "Заполнение заявки",
    noDescription: "Без описания",
    details: "Подробнее",
    detailsTitle: "Детали заявки",
    service: "Услуга:",
    status: "Статус:",
    currentStage: "Текущий этап:",
    summary: "Кратко:",
    description: "Описание:",
    stageDataEmpty: "Данные по этапу еще не заполнены",
    cancel: "Отмена",
    submitToCrm: "Отправить в CRM",
    servicesEmpty: "Список услуг пуст",
    statusLabels: {
      new: "Новая",
      in_progress: "В работе",
      completed: "Завершена",
      rejected: "Отклонена",
    },
    stageLabels: {
      fill: "Заполнение заявки",
      check: "Проверка данных",
      process: "В работе",
      done: "Завершение",
    },
    stageStates: {
      done: "Завершен",
      active: "Текущий",
      pending: "Ожидает",
    },
    analytics: {
      new: "Новые",
      inProgress: "В работе",
      completed: "Завершены",
      rejected: "Отклонены",
      resolutionSpeed: "Скорость решения",
      avgTime: "Среднее время",
      fastest: "Самое быстрое",
      lastActivity: "Последняя активность",
      lastResponse: "Последний ответ",
      lastRequest: "Последняя заявка",
      byService: "По услугам",
      noService: "Без услуги",
      days: "{n} дня",
      hours: "{n} часа",
    },
    tableColumns: {
      id: "ID",
      service: "Услуга",
      status: "Статус",
      created: "Создано",
      actions: "Действия",
    },
  },
  callHistory: {
    title: "Мои звонки",
    emptyList: "Нет истории звонков",
    caller: "Номер",
    media: "Тип связи",
    statusLabel: "Статус",
    duration: "Длительность",
    date: "Дата",
    rating: "Оценка",
    detailsTitle: "Детали звонка",
    case: "Результат",
    queue: "Очередь",
    startTime: "Начало",
    endTime: "Завершение",
    talkTime: "Разговор",
    waitTime: "Ожидание",
    totalTime: "Общее время",
    feedback: "Обратная связь",
    comment: "Комментарий",
    operators: "Операторы",
    recall: "Перезвонить",
    recallHint:
      "Начать новый звонок с тем же типом связи напрямую к этому оператору",
    sec: "сек",
    min: "мин",
    mediaTypes: {
      voice: "Голос",
      audio: "Аудио",
      video: "Видео",
      text: "Текст",
    },
    analytics: {
      answered: "Принято",
      missed: "Пропущено",
      other: "Прочие",
      metrics: "Показатели",
      totalCalls: "Всего звонков",
      avgTalkTime: "Ср. время разговора",
      avgWaitTime: "Ср. время ожидания",
      byMedia: "По типу связи",
    },
  },
  chatForm: {
    fileUploaded: "Файл успешно загружен",
    fileUploadedHint:
      "Теперь вы можете задать любой вопрос о содержимом документа",
    placeholder: "Введите вашу проблему или какую услугу хотите получить",
    tooLong:
      "Ваш запрос слишком длинный. Пожалуйста, укоротите его. Максимальное количество токенов: {limit}",
    maxTokens: "Максимальное количество токенов: {limit}",
    maxFiles: "Вы можете загрузить максимум {limit} файла",
    maxFileSize: "Файл не может быть больше {size}",
    attachedFiles: "Прикр. файлы: {count}",
  },
  stt: {
    init: "Получение доступа к микрофону ...",
    started: "Запись начата (нажмите Стоп для завершения)",
    micError: "Ошибка доступа к микрофону",
    uploading: "Загрузка аудио ...",
    uploadError: "Ошибка загрузки аудио",
    finished: "Загрузка аудио завершена",
  },
  search: {
    placeholder: "Поиск и фильтр",
    resetFilters: "Сбросить фильтры",
    appliedFilters: "Применено фильтров: {count}",
  },
  audio: {
    pause: "Пауза",
    listen: "Прослушать",
  },
  message: {
    you: "Вы",
    copy: "Скопировать",
  },
};
